import React from 'react';
import { useNavigate } from 'react-router-dom';
import {FaPersonWalkingLuggage} from "react-icons/fa6";
import {FaReceipt} from "react-icons/fa";
import { IoPersonCircleSharp } from "react-icons/io5";
import './Parent.css';

export default function Parent(){

    const navigate = useNavigate();

    const ParentHomeCardData = [
        {
            key: 1,
            icon: <FaPersonWalkingLuggage/>,
            title: 'Make Payments',
            infoText: 'View your passengers, add their tours, and make payments. ',
            navigateTo: 'passengers'
        },
        {
            key: 3,
            icon: <FaReceipt/>,
            title: 'Payment History',
            infoText: 'View all completed payments',
            navigateTo: 'payment-history'
        },
        {
            key: 2,
            icon: <IoPersonCircleSharp />,
            title: 'My Account',
            infoText: 'Manage your account',
            navigateTo: 'my-account'
        },
    ];

    return (
        <div className="parent-container h-100">
            {ParentHomeCardData.map((card) => (
                <div key={card.key} className="parent-card-container">
                    <div className="parent-card"  onClick={() => navigate(card.navigateTo)}>
                        <div className={"parent-card-icon-container " + card.navigateTo}><h1>{card.icon}</h1></div>
                        <h4>{card.title}</h4>
                        <div className="parent-card-info">{card.infoText}</div>
                    </div>
                </div>
            ))}


        </div>
    );
}
